import React from "react";
import Footer from "./Footer";
import "../css/infopages.scss";
import Header from "./Header";

function Contact() {
  return (
    <div className="contact">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title">
            <span className="base" data-ui-id="page-title-wrapper">
              Contact Us
            </span>
          </h1>
        </div>
        <div className="columns">
          <div className="column main">
            <p>
              We welcome your feedback and questions. Our support team is happy
              to help with products, orders, delivery, returns, and site access.
            </p>

            <h4>Email</h4>
            <p>
              <a href="mailto:group@hetcratehub.today">
                group@hetcratehub.today
              </a>
            </p>
            <p>&nbsp;</p>
            <p>Send us a message at any time and we will reply as soon as possible.</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
